export default __webpack_public_path__ + "static/media/LOC总磷自动分析仪用户手册_V2.0_fmt_pdf.7e479a72.pdf";